/**
 * @ngdoc service
 * @name common.service:WidgetService
 * @description
 * description
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('WidgetService', WidgetService);

    WidgetService.$inject = ['DUTTI_CONS', 'CmsConfigSvc'];

    function WidgetService(DUTTI_CONS, CmsConfigSvc) {
        var _this = this;

        inditex.onReady(function () {
            _this.isEnableAccessibilityWidget = false;

            var isWebApp = String(navigator.userAgent).toLowerCase().indexOf('massimodutti_ecom') > -1;

            function initWidget(doc, head, body) {
                var accessibilityScript = document.getElementById('accessibility-script');
                if (accessibilityScript) {
                    return true;
                }
                var coreCall = doc.createElement('script');
                coreCall.src = 'https://aacdn.nagich.com/core/4.2.1/accessibility.js';
                coreCall.defer = true;
                coreCall.integrity = 'sha512-RoBJzx90QrN0gC7WfhEIJRxInvLiYuAHS4D/f5h5iRt31pElVr2z7MtGOD+XBK0rKq8mjQaic2jX5gzTZ7WGZQ==';
                coreCall.crossOrigin = 'anonymous';
                coreCall.setAttribute('data-cfasync', true);
                coreCall.setAttribute('id', 'accessibility-script');
                body ? body.appendChild(coreCall) : head.appendChild(coreCall);
                hideAccessibilityButton();
            }

            function hideAccessibilityButton() {
                if (!_this.isEnableAccessibilityWidget) {
                    var accessibilityScript = document.getElementById('accessibility-script');
                    var btnAccesibilityStyle = document.createElement('style');
                    //btnAccesibilityStyle.innerHTML = `#INDmenu-btn{display:none}`;
                    accessibilityScript.parentNode.insertBefore(btnAccesibilityStyle, accessibilityScript);
                }
            }
            _this.openModal = function () {
                if (document.getElementById('accessibility-script')) {
                    document.getElementById('INDmenu-btn').click();
                } else {
                    _this.accessibilityWidget();
                    setTimeout(function () {
                        if (document.getElementById('INDmenu-btn')) {
                            document.getElementById('INDmenu-btn').click();
                        }
                    }, 1500);
                }
            };

            _this.accessibilityWidget = function () {
                initWidget(document, document.head, document.body);
            };

            if (!isWebApp) {
                _this.language = DUTTI_CONS.i_languages[inditex.iLangId].toLowerCase();

                if(_this.language === 'ga') _this.language = 'gl';
                if(_this.language === 'in') _this.language = 'id';

                CmsConfigSvc.getProperty('accessibilityWidget').then(function (enabledWidget) {

                    _this.isEnableAccessibilityWidget = enabledWidget;
                    window.interdeal = {
                        sitekey: 'ce8c8d7d980b57c8cae0264eabecece7',
                        Position: 'Left',
                        Menulang: _this.language,
                        domains: {
                            js: 'https://aacdn.nagich.com/',
                            acc: 'https://access.nagich.com/'
                        },

                        btnStyle: {
                            vPosition: ['92.7%', undefined],
                            scale: [0.5, 0.5],
                            icon: {
                                type: 11,
                                shape: 'circle',
                                outline: false
                            },
                            color: {
                                main: '#fff',
                                second: '#000'
                            }
                        }
                    };

                    if (enabledWidget) {
                        initWidget(document, document.head, document.body);
                    }
                });
            }
        });
    }
})();
